import { useCallback } from 'react';
import { useToken } from './useToken';
import axios from 'axios';

type UseAdminColorSyncHookType = () => () => Promise<void>

export const useAdminColorSync: UseAdminColorSyncHookType = () => {

  const token = useToken()

  return useCallback(async () => {
    const {data} = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/sync/colors`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    )
    return data
  }, [token])
}
